<template>
  <BtnDefault
    :mode="mode"
    :btnProps="btnPropsComputed"
    @click="copy"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { copyToClipboard } from "quasar";

export default defineComponent({
  name: "BtnClipboard",
  props: {
    text: {
      type: [String, Number, Boolean],
    },
    mode: {
      type: String as PropType<"default" | "icon" | "item">,
      default: "icon",
    },
    btnProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      modeProps: {
        default: {
          label: "Copy to clipboard",
        },
        icon: {
          icon: "content_copy",
          tooltip: "Copy to clipboard",
        },
        item: {
          label: "Copy to clipboard",
        },
      },
    };
  },
  computed: {
    btnPropsComputed(): any {
      return {
        size: "sm",
        ...this.modeProps[this.mode],
        ...this.btnProps,
      };
    },
  },
  methods: {
    copy() {
      void copyToClipboard(
        this.text
          ? typeof this.text == "string"
            ? this.text
            : typeof this.text == "object"
            ? JSON.stringify(this.text)
            : this.text?.toString()
          : ""
      );
      const message = "Copied to clipboard";
      this.$q.notify({ type: "positive", message: message });
    },
  },
});
</script>

<style lang="scss"></style>
